"use client";

import React from "react";
import Lottie from "lottie-react";

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Paragraph, Text } from "@/components/ui/typography";

import successCheckAnimation from "@/resources/lottie/success-check.json";

function PDPCallbackRequestedModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-95" showCloseButton={false}>
        <DialogTitle className="hidden">Emi Request Modal</DialogTitle>
        <div className="flex flex-col items-center-safe space-y-5">
          <Lottie
            animationData={successCheckAnimation}
            className="size-25"
            loop={false}
          />

          <div className="space-y-3">
            <Paragraph
              variant="b1-tight"
              weight="sb"
              className="text-grayscale-header-weak text-center"
            >
              Call Request Received!
            </Paragraph>
            <Text
              variant="small-tight"
              className="text-grayscale-label block text-center"
            >
              One of our counsellors will get in touch with you within few
              hours.
            </Text>
          </div>
        </div>

        <DialogClose asChild>
          <Button className="w-full mt-4">Got it</Button>
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
}

export default PDPCallbackRequestedModal;
